<div *ngIf="form" [formGroup]="form">
  <!-- Name -->
  <div class="form-group" appParentValidator [control]="form.controls.name">
    <div class="app-input" [class.disabled]="form.controls.source.value === rosterFileType.External && !form.controls.sourceId?.value">
      <label for="name">{{ 'NAME' | translate }}</label>
      <input appAutocompleteOff type="text" formControlName="name" class="form-control" id="name" [readonly]="form.controls.source.value === rosterFileType.External && !form.controls.sourceId?.value" />
    </div>

    <app-form-error [control]="form.controls.name"></app-form-error>
  </div>

  <!-- Source ID -->
  <div class="form-group" *ngIf="form.controls.sourceId?.value">
    <div class="app-input disabled">
      <label for="sourceId">{{ 'SOURCE_ID' | translate }}</label>
      <input type="text" [value]="form.controls.sourceId.value" class="form-control" id="sourceId" readonly />
    </div>
  </div>

  <!-- Description -->
  <div class="input-form-group form-group" appParentValidator [control]="form.controls.description">
    <div class="app-input">
      <label for="description">{{ 'DESCRIPTION' | translate }}</label>
      <textarea formControlName="description" class="form-control" id="description" rows="5"> </textarea>
    </div>
    <app-form-error [control]="form.controls.description"></app-form-error>
  </div>

  <!-- Type of roster -->
  <div class="input-form-group form-group" appParentValidator [control]="form.controls.type">
    <app-roster-type-select [className]="'app-input'" [form]="form"> </app-roster-type-select>

    <app-form-error [control]="form.controls.type"></app-form-error>
  </div>

  <!-- Access type management -->
  <div [hidden]="form.controls.type.value !== rosterType.Shared">
    <app-roster-adults-select [form]="form"> </app-roster-adults-select>
  </div>

  <!-- Status -->
  <div class="form-group pt-2">
    <app-status-checkbox [form]="form"> </app-status-checkbox>
  </div>
</div>
